module.exports = __webpack_public_path__ + "static/media/scroll.233516b7.png";